/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

const styles = {
  hideOnDesktop: () => css`
    ${breakpoints.up('md')} {
      display: none;
    }
  `,
  hideOnMobile: () => css`
    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
};

type Props = {
  children: React.ReactNode;
  css?: Interpolation<Theme>;
};

export const HideOnMobile = ({ children, css: cssProp }: Props) => (
  <div css={[styles.hideOnMobile, cssProp]}>{children}</div>
);

export const HideOnDesktop = ({ children, css: cssProp }: Props) => (
  <div css={[styles.hideOnDesktop, cssProp]}>{children}</div>
);
